import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

class PenalidadesApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async buscaPaginada(objFilterPagination) {
		const { paginacao, filtro, tipo, idEntidade } = objFilterPagination

		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.getUrlBuscaPaginada(),
			filters: { ...filtro, idEntidade, tipo },
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async validarPermissaoPenalidade({ idEntidade }) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.getUrlValidarPenalidade(),
			filters: {
				idEntidade: idEntidade,
			},
		}).build()
		return await axios.get(url)
	}

	async excluirPenalidade({ penalidade, tipo }) {
		return await axios.delete(`${this.urlBuilder.getUrlExcluirPenalidade()}/${penalidade.id}?tipo=${tipo.value}`)
	}
}

export default PenalidadesApiClient
